import React, { useState, useEffect, useContext } from 'react'
import './FullSchedule.css'
import './FullScheduleCards.css'
import { useParams, Link, NavLink } from 'react-router-dom'
import { AuthContext } from '../context/auth-context'
import Footer from '../components/UIElements/Footer'
import Arsenal from '../../images/Arsenal.png'
import BarrieKingsmen from '../../images/Barrie-kingsmen.png'
import ChicagoSouthsiders from '../../images/Chicago Southsiders.png'
import Dekheads from '../../images/Dekheads.png'
import Gods from '../../images/Gods.png'
import Graffix from '../../images/Graffix.png'
import Indians from '../../images/Indians.png'
import MidnightExpress from '../../images/Midnight Express.png'
import NightsWatch from '../../images/Nights Watch.png'
import NorthsideMilitia from '../../images/Northside Militia.png'
import PurplePower from '../../images/Purple Power.png'
import RoseCityRoyals from '../../images/Rose City Royals.png'
import Warriors from '../../images/Warriors.png'
import USA from '../../images/USA-logo.png'
import JrGods from '../../images/Team Pittsburgh Jr. Gods.png'
import Raptors from '../../images/Riverview Raptors.jpeg'
import Americans from '../../images/Americans.png'

const FullSchedule = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [allGamesAndEvents, setAllGamesAndEvents] = useState([])
	const [currentTournaments, setCurrentTournaments] = useState()
	const [isMobile440, setIsMobile440] = useState(false)
	//
	const auth = useContext(AuthContext)

	console.log('inside FullSchedule')

	//
	//
	useEffect(() => {
		const checkMobile = () => {
			setIsMobile440(window.matchMedia('(max-width: 440px)').matches)
		}

		checkMobile()

		window.addEventListener('resize', checkMobile)

		return () => {
			window.removeEventListener('resize', checkMobile)
		}
	}, [])

	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			try {
				const response = await fetch(
					process.env.REACT_APP_BACKEND_URL + '/admin/allGamesAndEvents',
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllGamesAndEvents(responseData.allItems)
				setCurrentTournaments(responseData.currentTournaments)

				setIsLoading(false)
			} catch (err) {
				setError(err.message)
			}
			setIsLoading(false)
		}
		sendRequest()
	}, [])
	//
	//
	const teamLogoMap = {
		'Penn Hills Arsenal': Arsenal,
		'Barrie Kingsmen': BarrieKingsmen,
		'Chicago Southsiders': ChicagoSouthsiders,
		'Iowa Dekheads': Dekheads,
		'Pittsburgh Gods': Gods,
		'Graffix Ball Hockey Club': Graffix,
		'Garden State Indians': Indians,
		'Brampton Midnight Express': MidnightExpress,
		"South Jersey Night's Watch": NightsWatch,
		'South Jersey Night’s Watch': NightsWatch,
		'Northside Militia': NorthsideMilitia,
		'Pittsburgh Purple Power': PurplePower,
		'Rose City Royals': RoseCityRoyals,
		'Garden State Warriors': Warriors,
		'USA Legends': USA,
		'Leominster Americans': Americans,
		'Pittsburgh Jr. Gods': JrGods,
		'Riverview Raptors': Raptors,
	}

	const getTeamLogo = (teamName) => teamLogoMap[teamName]
	//
	//
	const getWinningTeamClass = (game, team) => {
		if (!game.score) return ''

		const isWinner =
			(team === 'home' && game.winner === game.homeTeamId) ||
			(team === 'visitor' && game.winner === game.visitorTeamId)

		if (!isWinner) return ''

		const isPlayoff = game.playoff || game.championship || game.description

		return isPlayoff
			? 'mobileWinningTeam mobileWinningTeamPlayoff'
			: 'mobileWinningTeam'
	}
	//
	//
	const getDisplayScore = (game) => {
		if (!game.score) return ''

		return `${game.score}${game.scoreSuffix ? ` ${game.scoreSuffix}` : ''}`
	}
	//
	//
	//
	const errorHandler = () => {
		setError(null)
	}
	//
	//
	//
	let distinctVenues
	let distinctVenuesArray
	distinctVenuesArray = []

	if (allGamesAndEvents.length !== 0) {
		distinctVenues = [...new Set(allGamesAndEvents.map((x) => x.venueName))]
		for (let i = 0; i < distinctVenues.length; i++) {
			distinctVenuesArray.push(distinctVenues[i])
		}
	}

	let dateBlock
	dateBlock = []

	if (!isLoading && allGamesAndEvents.length === 0) {
		return (
			<React.Fragment>
				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>

				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}

	if (
		!isLoading &&
		allGamesAndEvents.length !== 0 &&
		currentTournaments.length !== 0 &&
		distinctVenuesArray
	) {
		distinctVenuesArray.forEach((venue) => {
			const gamesForVenue = allGamesAndEvents.filter(
				(game) => game.venueName === venue,
			)

			dateBlock.push(
				<div className='Schedule' style={{ marginTop: '1rem' }} key={venue}>
					<h1>{venue}</h1>

					{isMobile440 ? (
						<div className='mobileGameCards'>
							{gamesForVenue.map((game, key) => {
								const homeLogo = getTeamLogo(game.homeTeamName)
								const visitorLogo = getTeamLogo(game.visitorTeamName)

								const divisionLabel = game.playoff
									? game.playoffDivision
									: game.divisionName

								return (
									<div
										className={`mobileGameCard ${
											game.playoff || game.championship || game.description
												? 'mobileGameCardPlayoff'
												: ''
										}`}
										key={key}
									>
										<div className='mobileGameCardHeader'>
											<div>
												{game.dayOfWeek},{' '}
												{game.date.substr(0, 2) === '01' &&
													'Jan. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '02' &&
													'Feb. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '03' &&
													'Mar. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '04' &&
													'Apr. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '05' &&
													'May ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '06' &&
													'June ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '07' &&
													'July ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '08' &&
													'Aug. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '09' &&
													'Sept. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '10' &&
													'Oct. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '11' &&
													'Nov. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '12' &&
													'Dec. ' + game.date.substr(3, 2)}
											</div>

											<div className='mobileGameDivisionHeader'>
												<span>{divisionLabel}</span>

												{game.description && (
													<span className='mobileGameDescription'>
														{game.description}
													</span>
												)}
											</div>

											<div>
												{game.time.substr(0, 2) === '00' &&
													'12:' + game.time.substr(3, 2) + ' AM'}
												{game.time.substr(0, 2) === '01' &&
													'1:' + game.time.substr(3, 2) + ' AM'}
												{game.time.substr(0, 2) === '02' &&
													'2:' + game.time.substr(3, 2) + ' AM'}
												{game.time.substr(0, 2) === '03' &&
													'3:' + game.time.substr(3, 2) + ' AM'}
												{game.time.substr(0, 2) === '04' &&
													'4:' + game.time.substr(3, 2) + ' AM'}
												{game.time.substr(0, 2) === '05' &&
													'5:' + game.time.substr(3, 2) + ' AM'}
												{game.time.substr(0, 2) === '06' &&
													'6:' + game.time.substr(3, 2) + ' AM'}
												{game.time.substr(0, 2) === '07' &&
													'7:' + game.time.substr(3, 2) + ' AM'}
												{game.time.substr(0, 2) === '08' &&
													'8:' + game.time.substr(3, 2) + ' AM'}
												{game.time.substr(0, 2) === '09' &&
													'9:' + game.time.substr(3, 2) + ' AM'}
												{game.time.substr(0, 2) === '10' &&
													'10:' + game.time.substr(3, 2) + ' AM'}
												{game.time.substr(0, 2) === '11' &&
													'11:' + game.time.substr(3, 2) + ' AM'}
												{game.time.substr(0, 2) === '12' &&
													'12:' + game.time.substr(3, 2) + ' PM'}
												{game.time.substr(0, 2) === '13' &&
													'1:' + game.time.substr(3, 2) + ' PM'}
												{game.time.substr(0, 2) === '14' &&
													'2:' + game.time.substr(3, 2) + ' PM'}
												{game.time.substr(0, 2) === '15' &&
													'3:' + game.time.substr(3, 2) + ' PM'}
												{game.time.substr(0, 2) === '16' &&
													'4:' + game.time.substr(3, 2) + ' PM'}
												{game.time.substr(0, 2) === '17' &&
													'5:' + game.time.substr(3, 2) + ' PM'}
												{game.time.substr(0, 2) === '18' &&
													'6:' + game.time.substr(3, 2) + ' PM'}
												{game.time.substr(0, 2) === '19' &&
													'7:' + game.time.substr(3, 2) + ' PM'}
												{game.time.substr(0, 2) === '20' &&
													'8:' + game.time.substr(3, 2) + ' PM'}
												{game.time.substr(0, 2) === '21' &&
													'9:' + game.time.substr(3, 2) + ' PM'}
												{game.time.substr(0, 2) === '22' &&
													'10:' + game.time.substr(3, 2) + ' PM'}
												{game.time.substr(0, 2) === '23' &&
													'11:' + game.time.substr(3, 2) + ' PM'}
											</div>
										</div>

										<div className='mobileGameCardBody'>
											<div className='mobileGameTeam'>
												{homeLogo && (
													<img src={homeLogo} alt={game.homeTeamName} />
												)}
												<div className={getWinningTeamClass(game, 'home')}>
													{game.homeTeamAbbreviation || game.homeTeamName}
												</div>
											</div>

											{game.score ? (
												<Link
													className='mobileGameScore'
													to={`/gameSummary/${game._id}`}
												>
													{getDisplayScore(game)}
													<span>Final</span>
												</Link>
											) : (
												<div className='mobileGameScore mobileGameScoreEmpty'>
													<span>TBP</span>
												</div>
											)}

											<div className='mobileGameTeam'>
												{visitorLogo && (
													<img src={visitorLogo} alt={game.visitorTeamName} />
												)}
												<div className={getWinningTeamClass(game, 'visitor')}>
													{game.visitorTeamAbbreviation || game.visitorTeamName}
												</div>
											</div>
										</div>

										<div className='mobileGameVenue'>📍 {game.venueName}</div>
									</div>
								)
							})}
						</div>
					) : (
						<table id='defaultScheduleDisplay'>
							<thead>
								<tr>
									<th>Date/Time</th>
									{currentTournaments.length > 1 && <th>Tournament</th>}
									<th>Division</th>
									<th>Visitor/Home</th>
									<th></th>
									{auth.isLoggedIn && <th></th>}
									<th>Winner</th>
									<th>Score</th>
								</tr>
							</thead>

							<tbody>
								{gamesForVenue.map((game, key) => {
									return (
										<tr key={key}>
											<td>
												{game.dayOfWeek}
												{', '}
												{game.date.substr(0, 2) === '01' &&
													'Jan. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '02' &&
													'Feb. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '03' &&
													'Mar. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '04' &&
													'Apr. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '05' &&
													'May ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '06' &&
													'June ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '07' &&
													'July ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '08' &&
													'Aug. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '09' &&
													'Sept. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '10' &&
													'Oct. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '11' &&
													'Nov. ' + game.date.substr(3, 2)}
												{game.date.substr(0, 2) === '12' &&
													'Dec. ' + game.date.substr(3, 2)}
												<br />
												{game.time.substr(0, 2) === '00' &&
													'12:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '01' &&
													'1:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '02' &&
													'2:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '03' &&
													'3:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '04' &&
													'4:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '05' &&
													'5:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '06' &&
													'6:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '07' &&
													'7:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '08' &&
													'8:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '09' &&
													'9:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '10' &&
													'10:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '11' &&
													'11:' + game.time.substr(3, 2) + ' am'}
												{game.time.substr(0, 2) === '12' &&
													'12:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '13' &&
													'1:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '14' &&
													'2:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '15' &&
													'3:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '16' &&
													'4:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '17' &&
													'5:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '18' &&
													'6:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '19' &&
													'7:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '20' &&
													'8:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '21' &&
													'9:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '22' &&
													'10:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '23' &&
													'11:' + game.time.substr(3, 2) + ' pm'}
												{game.time.substr(0, 2) === '24' &&
													'12:' + game.time.substr(3, 2) + ' am'}
											</td>

											{currentTournaments.length > 1 && (
												<td>
													{(game.leagueName && game.leagueName) ||
														game.eventName}
												</td>
											)}

											{!game.playoff && <td>{game.divisionName}</td>}
											{game.playoff && <td>{game.playoffDivision}</td>}

											{game.visitorTeamName && (
												<td>
													{game.visitorTeamSeed > 0 &&
														'(' + game.visitorTeamSeed + ') '}
													{game.visitorTeamName}
													<br />
													{' @ '}
													<br />
													{game.homeTeamSeed > 0 &&
														'(' + game.homeTeamSeed + ') '}
													{game.homeTeamName}
													{game.description && (
														<div style={{ color: 'red', fontWeight: 'bold' }}>
															{'('}
															{game.description}
															{')'}
														</div>
													)}
												</td>
											)}

											{game.eventName && (
												<td
													style={{
														fontWeight: 'bold',
														backgroundColor: 'pink',
													}}
												>
													{game.eventName}
												</td>
											)}

											{game.description && <td></td>}
											{!game.playoff && !game.championship && <td></td>}

											{game.championship && (
												<td style={{ color: 'red', fontWeight: 'bold' }}>
													CHAMPIONSHIP GAME
												</td>
											)}

											{auth.isLoggedIn && (
												<td>
													{game.playoff &&
														!game.championship &&
														game.homeTeamName &&
														(game.homeTeamName === 'TBD' ||
															game.visitorTeamName === 'TBD') && (
															<NavLink
																className='navlinksEnterTeams'
																to={`/admin/updateGame/${game._id}`}
																exact
															>
																TEAMS
															</NavLink>
														)}
												</td>
											)}

											{game.homeTeamId && game.winner === game.homeTeamId && (
												<td>{game.homeTeamName}</td>
											)}

											{game.visitorTeamId &&
												game.winner === game.visitorTeamId && (
													<td>{game.visitorTeamName}</td>
												)}

											{game.status &&
												game.status !== 'TBP' &&
												game.winner !== game.homeTeamId &&
												game.winner !== game.visitorTeamId && <td>TIE</td>}

											{!game.score && <td></td>}

											<td>
												{game.score && (
													<Link
														style={{
															textDecoration: 'none',
															fontWeight: 600,
															color: 'black',
														}}
														to={`/gameSummary/${game._id}`}
													>
														{game.score}
														<span
															style={{ color: 'black', fontWeight: 'bold' }}
														>
															{game.scoreSuffix}
														</span>
													</Link>
												)}
											</td>
										</tr>
									)
								})}
							</tbody>
						</table>
					)}
				</div>,
			)
		})
	}

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				{dateBlock && dateBlock}
				<Footer />
			</React.Fragment>
		</div>
	)
}

export default FullSchedule
